<template>
  <div id="TranshipmentCouriersView">
    <v-dialog v-model="open" persistent max-width="500">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <h1 class="text-center">Entregadores</h1>
        </v-card-title>
        <v-card-text>
          <v-list v-if="!isLoading">
            <v-list-item v-for="courier in couriers" :key="courier.id">
              <v-list-item-avatar>
                <v-icon v-if="hasNoImage(courier.imageLink)"> mdi-account</v-icon>
                <v-img v-else :src="courier.imageLink"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title> {{ courier.name }} </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <router-link :to="`/transhipment-courier/${courier.id}`">
                      <v-icon class="cursor-pointer" v-bind="attrs" v-on="on"> mdi-eye </v-icon>
                    </router-link>
                  </template>
                  <span>Ir para detalhes</span>
                </v-tooltip>
              </v-list-item-icon>
            </v-list-item>
          </v-list>

          <div class="d-flex pt-4 justify-center"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between py-5">
          <v-btn color="info" class="flex-grow-1" large @click="close()"> VOLTAR </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'TranshipmentCouriersView',
  props: {
    open: {
      default: () => false,
      type: Boolean
    },
    couriers: {
      default: () => [],
      type: Array
    },
    isLoading: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({}),
  methods: {
    close() {
      this.$emit('closeCouriersView');
    },

    hasNoImage(imageLink) {
      return imageLink.includes('problem') ? true : false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
